import React from "react";
import { PointsWrapper, Parah, SubTitle, PointsIcon } from "../ContentsStyles";
import { ParahScrollLink } from "../../Pages/PagesStyles";

const TAC_6 = () => {
  return (
    <>
      <SubTitle>Your Rights</SubTitle>
      <Parah>
        You may end your relationship with Talents Explore at any time by simply
        closing your account and stopping your use of the Platform. Instructions
        for how to do this are in our Help Center. However, depending on your
        Platform settings, some of your content may still be available on the
        Platform after you delete your account.
      </Parah>
      <Parah>
        If you are an EEA-based consumer, then you can also close your account
        and withdraw from this contract at any time, either in-app or using the
        model withdrawal form here.
      </Parah>
      <Parah>
        In short: We want you to stay, but you can go whenever you want if you
        close your account and stop using the Platform. Your account applies
        across the Platform, so when you close your account within one Talents
        Explore website, you will lose access to your account across all other
        Talents Explore apps.
      </Parah>
      <SubTitle>Talents Explore’s Rights</SubTitle>
      <Parah>
        In the event of any suspected breach of these Terms and our Community
        Guidelines, we may investigate. While we do so, we are allowed to take
        down some or all of your content, or suspend your access to some or all
        the features of the Platform, acting reasonably and objectively
        depending on the seriousness of the suspected breach.
      </Parah>
      <Parah>
        We, subsequently, might determine to temporarily or permanently suspend
        or terminate your account, or impose limits on, or restrict your access
        to features of the Platform if:
      </Parah>
      <PointsWrapper>
        <PointsIcon /> we determine, acting reasonably and objectively, that you
        are in material or repeated breach of these Terms or our Community
        Guidelines.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        we have objective grounds to reasonably believe that you are about to
        seriously breach these Terms or our Community Guidelines.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon /> we are legally required to do so.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        it is reasonably required in response to dealing with a serious
        technical or security issue.
      </PointsWrapper>
      <Parah>
        If we have previously terminated your account for breaches of these
        Terms or Community Guidelines, but you use our Platform again (for
        example, by opening another account), we are entitled to suspend or
        terminate any such accounts.
      </Parah>
      <Parah>
        We will notify you in advance in order to allow you time to download
        your data in-app
        {/* (more information about how to do this is available
        here),  */}
        unless it is not appropriate for us to do so or we reasonably believe
        that continued access to your account will cause damage to us,
        Affiliates, our users or other third parties, or we are legally
        prevented from doing so.
      </Parah>
      <Parah>
        If you think we have made a mistake in suspending or terminating your
        account, you can appeal through the appeal functionalities provided on
        the Platform or by clicking{" "}
        <ParahScrollLink smooth={true} duration={500} to="contactUs">
          here
        </ParahScrollLink>{" "}
        and we will review our decision and decide again.
      </Parah>
      <Parah>
        For the avoidance of doubt, if we suspend or terminate your account, or
        you delete your account, you will lose access to all Talents Explore
        products
      </Parah>
      <Parah>
        In short: We have rules and, if you break them, Talents Explore can take
        action against you which may include closing your account. When your
        account is suspended or closed you will lose your access to the
        Platform, including all Talents Explore apps.
      </Parah>
    </>
  );
};

export default TAC_6;
